import React from 'react';
export function HowItWorks() {
  return <section className="w-full py-12 bg-white" data-id="element-155">
      <div className="max-w-4xl mx-auto px-4" data-id="element-156">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-center text-gray-800 mb-8" data-id="element-157">
          Die Wahrheit über TianSole: Was steckt hinter dem Prinzip?
        </h2>
        <div className="flex flex-col md:flex-row gap-8 items-center mb-12" data-id="element-158">
          <div className="md:w-1/2" data-id="element-159">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/swkfTcSbKJqY7dRw64TxHm/ChatGPT_Image_15._Juni_2025%2C_16_53_26.png" alt="Person demonstrating TianSole Einlegesohle with foot pain" className="w-full rounded-lg shadow-lg" data-id="element-160" />
          </div>
          <div className="md:w-1/2" data-id="element-161">
            <p className="text-lg text-gray-700 mb-4" data-id="element-162">
              Die Genialität von TianSole liegt in der Kombination zweier
              traditioneller Ansätze, die darauf abzielen, das Wohlbefinden zu
              fördern.
            </p>
            <p className="text-lg text-gray-700 mb-4" data-id="element-163">
              Stellen Sie sich vor, wie die 16 präzise geformten
              Akupressur-Erhebungen bei jedem Schritt sanft die Reflexzonen
              Ihrer Fußsohle stimulieren – Zonen, die in der traditionellen
              Lehre mit dem gesamten Körper in Verbindung stehen.
            </p>
            <p className="text-lg text-gray-700" data-id="element-164">
              Gleichzeitig erzeugen die strategisch platzierten Magnete ein
              sanftes Feld, das lokal die Durchblutung anregen und so zur
              Entspannung und zum Wohlbefinden beitragen kann. Das Ganze ist in
              eine orthopädisch geformte Sohle aus hochwertigem EVA-Material
              gebettet, für ganztägigen Komfort.
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-165">
          <div className="bg-teal-50 p-5 rounded-lg" data-id="element-166">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3EEv14bM3GiFoc5CamJDoz/ChatGPT_Image_15._Juni_2025%2C_17_30_16.png" alt="TianSole Akupressur-Technologie Illustration" className="w-full max-w-[300px] mx-auto h-auto object-contain rounded-lg shadow-md mb-4" data-id="element-167" />
            <h3 className="text-lg font-bold text-teal-800 mb-2" data-id="element-168">
              Akupressur-Technologie
            </h3>
            <p className="text-gray-700" data-id="element-169">
              16 strategisch platzierte Akupressur-Punkte stimulieren wichtige
              Reflexzonen im Fuß.
            </p>
          </div>
          <div className="bg-teal-50 p-5 rounded-lg" data-id="element-170">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/f4BWyKgFFFzu98vvwEFNd1/ChatGPT_Image_15._Juni_2025%2C_17_40_37.png" alt="Magnetfeld-Technologie Illustration" className="w-full max-w-[300px] mx-auto h-auto object-contain rounded-lg shadow-md mb-4" data-id="element-171" />
            <h3 className="text-lg font-bold text-teal-800 mb-2" data-id="element-172">
              Magnetfeld-Technologie
            </h3>
            <p className="text-gray-700" data-id="element-173">
              Sanfte Magnetfelder unterstützen die lokale Durchblutung und
              können zur Entspannung beitragen.
            </p>
          </div>
          <div className="bg-teal-50 p-5 rounded-lg" data-id="element-174">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/dvQjZ5KM1ndwJMU5e3KRcE/ChatGPT_Image_15._Juni_2025%2C_17_43_17.png" alt="Orthopädisches Design" className="w-full max-w-[300px] mx-auto h-auto object-contain rounded-lg shadow-md mb-4" data-id="element-175" />
            <h3 className="text-lg font-bold text-teal-800 mb-2" data-id="element-176">
              Orthopädisches Design
            </h3>
            <p className="text-gray-700" data-id="element-177">
              Ergonomisch geformte EVA-Einlegesohle für optimalen Tragekomfort
              den ganzen Tag.
            </p>
          </div>
        </div>
        <div className="bg-blue-50 border border-blue-100 p-6 rounded-lg" data-id="element-178">
          <h3 className="text-xl font-bold text-blue-800 mb-4" data-id="element-179">
            Die deutsche TianSole-Revolution: Andere Erfolgsgeschichten
          </h3>
          <p className="mb-4" data-id="element-180">
            Meine Geschichte ist kein Einzelfall. Überall in Deutschland
            entdecken Menschen TianSole als komplementäre Unterstützung.
          </p>
          <div className="space-y-4" data-id="element-181">
            <div className="bg-white p-4 rounded-md" data-id="element-182">
              <div className="flex items-center mb-2" data-id="element-183">
                <img src="https://images.unsplash.com/photo-1559839734-2b71ea197ec2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80" alt="Dr. Sandra M." className="w-12 h-12 rounded-full object-cover mr-4" data-id="element-184" />
                <div data-id="element-185">
                  <p className="font-bold" data-id="element-186">Dr. Sandra M.</p>
                  <p className="text-sm text-gray-600" data-id="element-187">Ärztin aus Hamburg</p>
                </div>
              </div>
              <p className="text-gray-700" data-id="element-188">
                "Als Ärztin war ich natürlich skeptisch. Aber nach Jahren
                eigener Leidensgeschichte mit Fibromyalgie war ich verzweifelt.
                Ich kann bestätigen, dass ich durch die konsequente Anwendung
                von TianSole die Unterstützung fand, die ich brauchte, um meine
                9 täglichen Tabletten unter ärztlicher Aufsicht schrittweise
                abzusetzen. Ich empfehle es nun ausgewählten Patienten, die nach
                komplementären Wegen suchen, um ihr Wohlbefinden zu verbessern."
              </p>
            </div>
            <div className="bg-white p-4 rounded-md" data-id="element-189">
              <div className="flex items-center mb-2" data-id="element-190">
                <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80" alt="Thomas S." className="w-12 h-12 rounded-full object-cover mr-4" data-id="element-191" />
                <div data-id="element-192">
                  <p className="font-bold" data-id="element-193">Thomas S., 44</p>
                  <p className="text-sm text-gray-600" data-id="element-194">Polizist aus München</p>
                </div>
              </div>
              <p className="text-gray-700" data-id="element-195">
                "Dienstunfähig wegen chronischer Fußschmerzen, 18 Monate
                Medikamente. TianSole verhalf mir dabei, in 5 Wochen wieder
                volldiensttauglich zu werden. Der Polizeiarzt kann es nicht
                erklären."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}